export default {"src":"/_next/static/media/Comprehensive and Personalized Care cardiology.2d4571ef.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};